
// THIS IS SUPER WEIRD
// IT said I needed to add in the commented global BigInt to get rid of a warning and...it worked?
// When I'm with Jimoh, def take a look at this

/* global BigInt */
import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import axios from 'axios';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Typography,
  message,
  Alert,
  Modal,
  ConfigProvider,
  theme
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { toast } from 'react-toastify';
import { Coinbase_Auth_Token, DEFAULT_GHOST_FEE_THRESHOLD } from "../../const/const";
import CryptoAccountLoginStatus from "../CryptoAccountLoginStatus";
import { getAccountData } from "../../rest/crypto-api/coinbase";
import { useAuth } from "../../contexts/auth-context";
import {
  metamaskSendUSDC,
  checkMetaMaskAndNetwork,
  handleOnlyGhostFeePaymentForMetamask,
  handleTransactionSplitPaymentForMetamask,
  handleOnlyGhostFeePaymentForCoinbase,
  handleTransactionSplitPaymentForCoinbase
} from '../../helpers';
import { useLegalDocDialog } from '../../hooks/legal-doc';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};


// GK 10/22/2023 - Creates the Transaction submission form
// We should add in a network as a variable. So 'solana' or 'ethereum'
const Transaction = () => {
  const storage = localStorage;
  const navigate = useNavigate();
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage(); //This comes from ANT Design, we are using this to help display error messages
  const [account, setAccount] = useState([]);
  const [twoFactorRequire, setTwoFactorRequire] = useState(false);
  const [coinbaseSplitPaymentStep, setCoinbaseSplitPaymentStep] = useState(0); // 1 => 1st-payment in-progress, 2 => 2nd payment in-progress
  const { Title, Text } = Typography;
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [unpaidGhostFeesBeforeError, setUnpaidGhostFeesBeforeError] = useState(null);
  const [twoFAError, setTwoFAError] = useState(null);
  const [loading, setLoading] = useState(false);
  const coinbaseUserAuthData = useSelector((state) => state.coinbase.coinbaseUserAuth.data?.oauth_meta);
  const cryptoAccount = useSelector(state => state.cryptoAccount.account);
  const auth = useAuth();

  useLegalDocDialog();

  const loginEmail = auth.currentUser?.email;
  const notSignedInCorrectly = ["userinput", "gemini"].includes(cryptoAccount.data?.exchange?.toLowerCase());
  const ethusdc_address = cryptoAccount.data?.ethusdc_address;
  const signedInWithMetamask = cryptoAccount.data?.exchange?.toLowerCase() === 'metamask';
  const signedInWithCoinbase = cryptoAccount.data?.exchange?.toLowerCase() === 'coinbase';
  let toastId = null;


  // GK 2023-10-22 - This shows errors via Toast, which we arent using anymore
  const showError = (message) => {
    if (!toast.isActive(toastId)) {
      toastId = toast.error(message, {
        onClose() {
          toastId = null;
        }
      });
    }
  };

  // GK 2023-10-22 - This fetches an account via Axios
  const fetchCoinbaseAccount = async () => {
    const errorMessage = <div>
      You must be logged in with Coinbase to pay someone. Please <Link to="/crypto-login" class="light-blue">login</Link> to proceed!
    </div>;

    try {
      const coinbaseAuthToken = storage.getItem(Coinbase_Auth_Token);
      const response = await getAccountData(coinbaseAuthToken, 'USDC');

      if (response) {
        setAccount(response);
      } else {
        setError(errorMessage);
      }

    } catch (error) {
      // If the error response indicates an expired token, sign out the user
      if (error.response && error.response.data.errorCode === 'TOKEN_EXPIRED') {
        auth.signOut();
      }
      setError(errorMessage);
    }
  }


  // GK 2023-10-22 - This fetches the account when the component renders
  useEffect(() => {
    if (signedInWithCoinbase) {
      fetchCoinbaseAccount();
    }
  }, []);

  // something like "if user is signed in with metamask, then run this:"
  useEffect(() => {
    if (signedInWithMetamask) {
      checkMetaMaskAndNetwork(ethusdc_address).then(result => {
        if (result.success) {
          console.log("All checks passed. Wallet address:", result.address);
        } else {
          console.error("Check failed:", result.error);
          setError(result.error);
        }
      });
    }
  }, []);

  const handleTransactionError = (error, { unpaidhostFeesBeforeErrorValue } = {}) => {
    console.log('Transaction Create: Error =>', error);
    // If the error response indicates an expired token, sign out the user
    if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
      auth.signOut();
    }

    setLoading(false);

    // if metamask error
    if (error.code === 4001) {
      setError("Transaction rejected by the user.");
      console.error("User denied transaction signature.");
      // Return error information
      return;
    }

    const errorData = error.response?.data;
    if (errorData?.errorCode) { // This means the error is our customized error from the server
      setError(errorData.message);
      return;
    }

    setError(error.message); // catch other errors

    console.log('Transaction Create: 2FA Auth required =>', errorData);
    let twoFAErrorString = "";
    // GK 2023-10-22 - the errorData is an array coming from coinbase, we are looking for the "id" key
    errorData?.errors?.forEach((err) => {
      if (err?.id === "two_factor_required") {
        if (unpaidhostFeesBeforeErrorValue) { // this will be used by Coinbase SplitPayment second request with OTP
          setUnpaidGhostFeesBeforeError(unpaidhostFeesBeforeErrorValue);
        }

        setTwoFactorRequire(true); // triggers the 2FA modal
        setError(null); // unset component error message since this already triggers modal
      } else {
        twoFAErrorString += err?.message + "\n";
      }
    });

    if (twoFAErrorString) {
      setTwoFAError(twoFAErrorString);
      setError(null); // unset component error message since this will be shown in the modal error 
      return;
    }

  }



  // GK 2023-10-22 - When the submit button is pressed, the send-crypto api call gets run with the supplied requestData
  const onFinish = async (value) => {
    console.log('Form value ===>', value);
    // if(!account) {
    //   setError('Can\'t fetch the user account. Please login again to perform this operation.')
    //   return;
    // }

    if (!loginEmail) {
      setError('Can\'t fetch the user login email. Please login again to perform this operation.');
      return;
    }

    // If exchange = coinbase, do something, else if metamask, do something else
    if (signedInWithCoinbase) {
      if (Number(value.amount) < 1) {
        setError('Amount can\'t be less than 1 for Coinbase transaction.');
        return;
      }
      setLoading(true);
      // I SHOULD GET THIS WHOLE TRY BLOCK TO RUN ASYNCHRONOUSLY
      try {


        const toAndFromData = {
          to: value.recipient.toLowerCase().trim(),
          from: loginEmail,
        };

        const toAndFrom = await axios.post('/api/transactions/get-ethusdc-sender-receiver', toAndFromData);
        console.log('toAndFrom-->', toAndFrom)
        // GK 2026-02-23 define the threshold amount for when to send fees
        // This will typically be one variable - eg, $10  
        // This would sometiems come from the "pay_after" value returned from the Fees table
        
        const ghostFeeThresholdAmount = toAndFrom.data?.recipientFee?.pay_after > DEFAULT_GHOST_FEE_THRESHOLD ?
          toAndFrom.data?.recipientFee?.pay_after : DEFAULT_GHOST_FEE_THRESHOLD;

        // SplitPayment second payment request (WITH twoFactorCode): Last Modal during the split payment
        if (unpaidGhostFeesBeforeError && twoFactorRequire && value.twoFactorToken && coinbaseSplitPaymentStep === 2) {
          console.log("Coinbase txn: Finish split payment")
          await handleTransactionSplitPaymentForCoinbase(
            {
              sentTo: toAndFrom.data.sent_to,
              sentFrom: toAndFrom.data.sent_from,
              unpaidGhostFees: unpaidGhostFeesBeforeError,
              formValue: value,
              senderEmail: loginEmail,
              isTransactionFee: false,
              transactionFeeId: value.transactionFeeId,
              accountId: account.id,
              twoFactorRequire,
              handleRecipientPaymentSuccess: (successData) => {
                navigate("/transactions");
                setLoading(false);
                setUnpaidGhostFeesBeforeError(null);
              },
              handleError: handleTransactionError
            }
          );
          return;
        }
        /**
        ********* (2 Payments: ghost fees to Punkypay, the remaining amount to the recipient) ********  
        * If the amount entered is greater than ghost fee. (2 payments)
        * and the ghost fee that needs to be paid is greater than or equal to the threshold (ghostFeeThresholdAmount)
        * and the recipient amount that needs to be paid is greater than or equal to coinbase minimum (1)
        */
        if (toAndFrom.data.unpaidGhostFees?.total >= ghostFeeThresholdAmount && (Number(value.amount) - toAndFrom.data.unpaidGhostFees?.total) >= 1) {
          console.log("Coinbase txn: Initiate split payment")
          // SplitPayment first payment request (WITH twoFactorCode)
          if (twoFactorRequire && value.twoFactorToken) {
            await handleTransactionSplitPaymentForCoinbase(
              {
                sentTo: toAndFrom.data.sent_to,
                sentFrom: toAndFrom.data.sent_from,
                unpaidGhostFees: toAndFrom.data.unpaidGhostFees,
                formValue: value,
                senderEmail: loginEmail,
                isTransactionFee: true,
                transactionFeeId: undefined,
                accountId: account.id,
                twoFactorRequire,
                handleTransactionFeePaymentSuccess: (transactionFeeData) => {
                  setCoinbaseSplitPaymentStep(2);

                  form.resetFields(['twoFactorToken']);
                  setTwoFactorRequire(false);
                  setTwoFAError(null);
                  if (transactionFeeData) {// set the transactionFeeId to link with the next second payment
                    form.setFieldsValue({ transactionFeeId: transactionFeeData._id });
                  }
                },
                handleError: handleTransactionError
              }
            );
            return;
          }

          // SplitPayment first payment request (NO twoFactorCode)
          Modal.confirm({
            title: `You’re about to send this payment in two parts:`,
            content: (
              <>
                <strong>1. Fee payment:</strong> ${toAndFrom.data.unpaidGhostFees?.total}
                <br />
                You will pay fees owed by {value.recipient.toLowerCase()} to Punkypay.
                This will be applied on their behalf and count as part of your payment to them.

                <br /><br />

                <strong>2. Recipient payment:</strong> $
                {(
                  Number(value.amount) -
                  Number(toAndFrom.data.unpaidGhostFees?.total || 0)
                ).toFixed(2)}
                <br />
                Sent directly to {value.recipient.toLowerCase()}.

                <br /><br />

                <strong>Total:</strong> ${Number(value.amount).toFixed(2)}
              </>
            ),
            maskClosable: false,
            closable: false,
            visible: false, // Start hidden
            okText: 'Continue',
            onOk: () => {
              handleTransactionSplitPaymentForCoinbase(
                {

                  sentTo: toAndFrom.data.sent_to,
                  sentFrom: toAndFrom.data.sent_from,
                  unpaidGhostFees: toAndFrom.data.unpaidGhostFees,
                  formValue: value,
                  senderEmail: loginEmail,
                  isTransactionFee: true,
                  transactionFeeId: undefined,
                  accountId: account.id,
                  twoFactorRequire: false,
                  // hooks that runs after first payment is successful and just before modal for second payment pops up 
                  handleTransactionFeePaymentSuccess: (successData) => {
                    // activate second payment step
                    setCoinbaseSplitPaymentStep(2);
                  },
                  handleError: handleTransactionError
                }
              );
            },
            onCancel: () => setLoading(false)

          });

          return;
        }

        /**
        * ******************** (1 Payment to Punkypay) ************************
        * If amount entered is less than or equal to Ghost fee
        * and the ghost fee is equal to or more than the threshold (ghostFeeThresholdAmount)
        * NOTE: the THRESHOLD must be equal to more than coinbase minimum (which is 1 for now)
        */
        if (toAndFrom.data.unpaidGhostFees?.total >= ghostFeeThresholdAmount && value.amount <= toAndFrom.data.unpaidGhostFees?.total) {
          console.log("Coinbase txn: Amount entered less than ghost fee.")
          // when two factor is required (second request sent to Coinbase with two-factor code)
          if (twoFactorRequire && value.twoFactorToken) {
            try {
              const responseSaveInDatabase = await handleOnlyGhostFeePaymentForCoinbase(value, loginEmail, account.id, toAndFrom.data.unpaidGhostFees.transactionsAndFees, twoFactorRequire);
              if (responseSaveInDatabase) {
                setTwoFactorRequire(false);
                navigate("/transactions");
                setLoading(false);
              }
            } catch (error) {
              handleTransactionError(error);
            }

            return;
          }

          // When two factor is not required. (first request sent to Coinbase)
          Modal.confirm({
            title: `Payment for $${value.amount} will be made to Punkypay`,
            content: `The recipient (${value.recipient.toLowerCase()}) has an outstanding balance with Punkypay. 
              Your payment will be sent to Punkypay on their behalf and applied toward this balance. 
              This should be treated as payment to the recipient.`,
            maskClosable: false,
            closable: false,
            visible: false, // Start hidden
            okText: 'Continue',
            onOk: async () => {
              try {
                const responseSaveInDatabase = await handleOnlyGhostFeePaymentForCoinbase(value, loginEmail, account.id, toAndFrom.data.unpaidGhostFees.transactionsAndFees, twoFactorRequire);
                console.log('responseSaveInDatabase ===>', responseSaveInDatabase);
                if (responseSaveInDatabase) {
                  console.log('Coinbase Transaction Created successfully ::=>', responseSaveInDatabase);
                  navigate("/transactions");
                  setLoading(false);
                }
              } catch (error) {
                handleTransactionError(error);
              }
            },
            onCancel: () => setLoading(false)
          });
          return;
        }

        /**
         * ************************* DEFAULT PAYMENT (1 payment to recipient) ***********************
         * If there is no ghost fee and the amount entered is greater than or equal to coinbase minimum
         * or there is a ghost fee but the ghost fee is not up to the threshold
         */
        console.log("Coinbase txn: Default payment")
        const requestData = {
          accountId: account.id,
          accessToken: storage.getItem(Coinbase_Auth_Token),
          to: value.recipient.toLowerCase().trim(),
          from: loginEmail,
          amount: value.amount,
          currency: "USDC",
          network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
          shortMemo: value.shortMemo,
          notes: value.notes,
          isTransactionFee: false,
          totalAmountUserEntered: value.amount,
          splitPaymentStatus: 'no',
          twoFactorToken: twoFactorRequire ? value?.twoFactorToken : null,
        };

        const response = await axios.post('/api/transactions/send-crypto-coinbase', requestData);

        if (response) {
          console.log('Transaction Created successfully =>', response.data);
          navigate("/transactions");
          setLoading(false);
        }
      } catch (error) {
        handleTransactionError(error);
      }
    }

    if (signedInWithMetamask) {
      setLoading(true);

      try {

        const toAndFromData = {
          // accountId: account.id, // I dont think I need this for metamask? or I should use the crypto address? I think this is supposed to be the ethusdc_account identifier?
          // accessToken: storage.getItem(Coinbase_Auth_Token), //I won't need this
          to: value.recipient.toLowerCase().trim(),
          from: loginEmail,
          amount: value.amount,
          currency: "USDC",
          network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
          shortMemo: value.shortMemo,
          notes: value.notes,
          withPunkypayData: true
        };

        // I decided to run this command, rather than running the sendUSDC() metamask function directly, 
        // becasue I think the code will be more readable when I put it in the API function call
        // GK 2025-09-27: The get-ethusdc-sender-receiver function (below) should be merged into the metamaskSendUSDC function
        // With Coinbase sends, something similar is done. 
        const toAndFrom = await axios.post('/api/transactions/get-ethusdc-sender-receiver', toAndFromData);
        console.log('toAndFrom ===>', toAndFrom);
        // If transaction is a special payment
        if (toAndFrom.data.isSpecialPaymentFromTo) {
          const responseSendUSDC = await metamaskSendUSDC(toAndFrom.data.sent_to, toAndFrom.data.sent_from, toAndFromData.amount);

          console.log(responseSendUSDC.txHash);
          console.log(responseSendUSDC.gasInfo.estimatedCostUSDC);
          const sendCryptoData = {
            to: value.recipient.toLowerCase().trim(),
            from: loginEmail,
            amount: value.amount,
            currency: "USDC",
            network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
            txn_id: responseSendUSDC.txHash,
            gas_cost: responseSendUSDC.gasInfo.estimatedCostUSDC.toString(),
            shortMemo: value.shortMemo,
            notes: value.notes,
            isTransactionFee: false,
            totalAmountUserEntered: value.amount,
            splitPaymentStatus: 'no',
            isSpecialPaymentFromTo: true,
          };

          const responseSaveInDatabase = await axios.post('/api/transactions/send-crypto-metamask', sendCryptoData);

          if (responseSaveInDatabase) {
            console.log('Transaction Created successfully =>', responseSaveInDatabase.data);
            navigate("/transactions");
            setLoading(false);
          }
          return;
        }
        // Create modal for back button attempts
        const ghostFeeThresholdAmount = toAndFrom.data?.recipientFee?.pay_after > DEFAULT_GHOST_FEE_THRESHOLD ?
          toAndFrom.data?.recipientFee?.pay_after : DEFAULT_GHOST_FEE_THRESHOLD;

        // if there is a ghost fee and amount entered is more than the ghost fee and threshold is hit, two transactions are made
        if (toAndFrom.data.unpaidGhostFees?.total >= ghostFeeThresholdAmount && value.amount > toAndFrom.data.unpaidGhostFees?.total) {
          console.log("Metamask txn: Split payment initiated")
          Modal.confirm({
            title: `You’re about to send this payment in two parts:`,
            content: (
              <>
                <strong>1. Fee payment:</strong> ${toAndFrom.data.unpaidGhostFees?.total}
                <br />
                You will pay fees owed by {value.recipient.toLowerCase()} to Punkypay.
                This will be applied on their behalf and count as part of your payment to them.

                <br /><br />

                <strong>2. Recipient payment:</strong> $
                {(
                  Number(value.amount) -
                  Number(toAndFrom.data.unpaidGhostFees?.total || 0)
                ).toFixed(2)}
                <br />
                Sent directly to {value.recipient.toLowerCase()}.

                <br /><br />

                <strong>Total:</strong> ${Number(value.amount).toFixed(2)}
              </>
            ),
            maskClosable: false,
            closable: false,
            visible: false, // Start hidden
            okText: 'Continue',
            onOk: () => {
              handleTransactionSplitPaymentForMetamask(
                {
                  sentTo: toAndFrom.data.sent_to,
                  sentFrom: toAndFrom.data.sent_from,
                  unpaidGhostFees: toAndFrom.data.unpaidGhostFees,
                  formValue: value,
                  senderEmail: loginEmail,
                  isTransactionFee: true,
                  punkypayPaymentAddress: toAndFrom.data.punkypayData?.ethusdc_address,
                  punkypayPaymentEmail: toAndFrom.data.punkypayData?.email,
                  handleSuccess: (successData) => {
                    navigate("/transactions");
                    setLoading(false);
                  },
                  handleError: handleTransactionError
                }
              );
            },
            onCancel: () => setLoading(false)

          });

          return;
        }

        // If the amount entered is less than or equal to the ghost fee and threshold is hit, one transaction is made
        if (toAndFrom.data.unpaidGhostFees?.total >= ghostFeeThresholdAmount && value.amount <= toAndFrom.data.unpaidGhostFees?.total) {

          Modal.confirm({
            title: `Payment of $${value.amount} will be made to Punkypay`,
            content: `The recipient (${value.recipient.toLowerCase()}) has an outstanding balance with Punkypay. 
            Your payment will be sent to Punkypay on their behalf and applied toward this balance. 
            This should be treated as payment to the recipient.`,
            maskClosable: false,
            closable: false,
            visible: false, // Start hidden
            okText: 'Continue',
            onOk: async () => {
              try {
                const responseSaveInDatabase = await handleOnlyGhostFeePaymentForMetamask(
                  toAndFrom.data.sent_from, value, loginEmail, toAndFrom.data.unpaidGhostFees.transactionsAndFees, toAndFrom.data.punkypayData?.ethusdc_address, toAndFrom.data.punkypayData?.email
                );
                if (responseSaveInDatabase) {
                  console.log('Transaction Created successfully ::=>', responseSaveInDatabase.data);
                  navigate("/transactions");
                  setLoading(false);
                }
              } catch (error) {
                handleTransactionError(error);
              }
            },
            onCancel: () => setLoading(false)
          });
          return;
        }

        // Default when ghost fees do not hit threshold
        console.log("Metamask txn: Default payment")
        const responseSendUSDC = await metamaskSendUSDC(toAndFrom.data.sent_to, toAndFrom.data.sent_from, toAndFromData.amount);

        console.log(responseSendUSDC.txHash);
        console.log(responseSendUSDC.gasInfo.estimatedCostUSDC);
        const sendCryptoData = {
          // accountId: account.id, // I dont think I need this for metamask? or I should use the crypto address? I think this is supposed to be the ethusdc_account identifier?
          // accessToken: storage.getItem(Coinbase_Auth_Token), //I won't need this
          to: value.recipient.toLowerCase().trim(),
          from: loginEmail,
          amount: value.amount,
          currency: "USDC",
          network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
          txn_id: responseSendUSDC.txHash,
          gas_cost: responseSendUSDC.gasInfo.estimatedCostUSDC.toString(),
          shortMemo: value.shortMemo,
          notes: value.notes,
          isTransactionFee: false,
          totalAmountUserEntered: value.amount,
          splitPaymentStatus: 'no',
        };

        const responseSaveInDatabase = await axios.post('/api/transactions/send-crypto-metamask', sendCryptoData);

        if (responseSaveInDatabase) {
          console.log('Transaction Created successfully =>', responseSaveInDatabase.data);
          navigate("/transactions");
          setLoading(false);
        }
      } catch (error) {
        handleTransactionError(error);
      }
    }
    // Note: if you arent signed in with Coinbase or Metamask, another error message will catch this. 
    // Please look at code below. 
    // I should probably remove the ability to see the Pay Now form, but that is for another time. 
  }

  const handle2FASubmit = async () => {
    if (loading) return;

    setTwoFAError(null);

    const formValues = await form.validateFields();
    await onFinish(formValues);
  }

  const handle2FACancel = async () => {
    if (loading) return;

    form.resetFields(['twoFactorToken']);
    setTwoFactorRequire(false);

    setTwoFAError(null);
  }
  // Keep this code - this is valuable if I am 
  // working with metamask and dont submit the transaction with enough gas. 

  // NEVER ENDED UP NEEDING THIS TO CLEAN TRANSACTIONS IN METAMASK, BUT IT WORKED
  // const isMetaMaskBusy = async () => {
  //   const pendingRequests = await window.ethereum.request({
  //     method: 'wallet_getPermissions',
  //     params: [{ eth_accounts: {} }]
  //   });
  //   console.log("Pending Requests:", pendingRequests); // Log the pending requests

  //   return pendingRequests.length > 0;
  // };

  // // Before sending a new transaction
  // if (isMetaMaskBusy()) {
  //   console.warn("MetaMask already has a pending request. Please wait.");
  //   // "Ah, huge bummer. Metamask had an issue. You have to backup your seed phrase from metamask, and then reset it. Look at this guide to help."
  //   return;
  // }

  // THIS CLEANED TRANSACTIONS IN METAMASK ... WHAT IF THERE WAS A TRANSACTION I WANTED TO GO THROUGH
  // HOW DID THE GAS NOT BE ENOUGH THAT ONE TIME...??

  // const cancelPendingTransaction = async () => {
  //   try {
  //     // 1. Ensure MetaMask is available
  //     if (typeof window.ethereum === 'undefined') {
  //       console.error("MetaMask is not installed!");
  //       return;
  //     }

  //     // 2. Get the user's accounts
  //     const accounts = await window.ethereum.request({ method: 'eth_accounts' });
  //     const account = accounts[0]; // Get the first account

  //     if (!account) {
  //       console.error("No account found in MetaMask.");
  //       return;
  //     }

  //     // 3. Get the current nonce for the user's address
  //     const nonce = await window.ethereum.request({
  //       method: 'eth_getTransactionCount',
  //       params: [account, 'latest'], // Get nonce for the latest transactions
  //     });

  //     console.log("Current Nonce:", nonce);

  //     // 4. Get the current gas price
  //     const gasPrice = await window.ethereum.request({
  //       method: 'eth_gasPrice', // Fetch current gas price
  //     });

  //     const newGasPrice = (parseInt(gasPrice, 16) * 2).toString(16); // Double the current gas price

  //     // 5. Prepare a new transaction using the same nonce but higher gas price
  //     const newTransaction = {
  //       from: account,
  //       to: account, // Send it to your own address to avoid changing the state
  //       value: '0x0', // No value transfer
  //       gasPrice: newGasPrice, // Use the new higher gas price
  //       nonce: nonce, // Same nonce as the pending transaction
  //     };

  //     // 6. Send the new transaction
  //     const txHash = await window.ethereum.request({
  //       method: 'eth_sendTransaction',
  //       params: [newTransaction],
  //     });

  //     console.log("Cancelled pending transaction by sending a new one. TX Hash:", txHash);
  //   } catch (error) {
  //     console.error("Error cancelling transaction:", error);
  //   }
  // };

  // // Run the method
  // cancelPendingTransaction();

  // GK 2023-10-22 - below is the HTML for the transaction component
  return (
    <div style={{ marginTop: "10px" }}>
      <Title className="text-center" level={3}>Pay Now</Title>
      <div className="text-center" style={{ marginBottom: '10px' }}>
        <CryptoAccountLoginStatus />
      </div>
      {/* Below does not work anymore because Coinbase broke the User Auth endpoint */}
      {/* {
        coinbaseUserAuthData && !notSignedInCorrectly && (
          <div className="text-center" style={{marginBottom: '10px'}}>
            <Text
              style={{marginBottom: '5px'}} 
              type="warning"
            >
              You can only send {
              coinbaseUserAuthData.send_limit_amount
              } {
              coinbaseUserAuthData.send_limit_currency
              } per {
                coinbaseUserAuthData.send_limit_period
              } based on your coinbase settings
            </Text>
          </div>
        )
      } */}

      <Form
        labelCol={{
          xs: { span: 24 },
          md: { span: 8 }
        }}
        wrapperCol={{
          xs: { span: 24 },
          md: { span: 8 },
        }}
        form={form}
        name="transaction"
        onFinish={onFinish}
        validateMessages={validateMessages}
      // style={{ maxWidth: 800, margin: "auto" }}
      >

        <Form.Item
          name={"recipient"}
          label={"Recipient's Punkypay Email"}
          rules={[{ required: true }]}
          className="form-item"
        >
          <Input placeholder={"Recipient"} maxLength={225} disabled={twoFactorRequire} />
        </Form.Item>
        <Form.Item
          name={"amount"}
          label={"Amount (USDC)"}
          rules={[{ required: true }]}
          className="form-item"
        >
          <InputNumber
            placeholder={"Amount"}
            style={{ width: "100%" }}
            min={0}
            disabled={twoFactorRequire}
          />
        </Form.Item>
        <Form.Item
          name={"shortMemo"}
          label={"Short Memo"}
          rules={[{ required: true }]}
          className="form-item"
        >
          <Input placeholder={"Short Memo"} maxLength={225} disabled={twoFactorRequire} />
        </Form.Item>
        <Form.Item
          name={"notes"}
          label={"Notes"}
          rules={[{ required: false }]}
          className="form-item"
        >
          <TextArea disabled={twoFactorRequire} />
        </Form.Item>
        <Form.Item name={"transactionFeeId"} hidden>
          <Input />
        </Form.Item>
        <Form.Item
          className="form-item form-item__submit"
          wrapperCol={{
            md: {
              offset: 8,
              span: 16,
            },
            xs: {
              span: 24,
            },
          }}
        >
          <Button type="primary" htmlType="submit" disabled={loading || notSignedInCorrectly || auth?.maintenanceMode?.toLowerCase() === 'on'}>
            Submit
          </Button>
        </Form.Item>
        <ConfigProvider
          theme={{
            algorithm: theme.defaultAlgorithm,
          }}
        >
          <Modal
            title="Two factor Verification"
            closable={!loading && { 'aria-label': 'Custom Close Button' }}
            maskClosable={!loading}
            open={twoFactorRequire}
            onOk={handle2FASubmit}
            onCancel={handle2FACancel}
            okText="Submit"
            confirmLoading={loading}
            cancelButtonProps={{ disabled: loading }}
          >
            <p style={{ paddingLeft: '10px' }}>Please enter two-factor authentication code for Coinbase. You will recieve the code on an authenticator app, text message, email, or security prompt.</p>
            {coinbaseSplitPaymentStep == 2 && <Alert className="text-center" style={{ marginBottom: '20px' }} message={"Note: You cannot use the same code as you did with the previous transaction."} type="warning" />}
            {
              twoFAError && (
                <Row>
                  <Col
                    span={24}
                    style={{ marginTop: "5px", marginBottom: "20px" }}
                  >
                    <Alert className="text-center" message={twoFAError} type="error" />
                  </Col>
                </Row>
              )
            }
            <Form.Item
              name={"twoFactorToken"}
              label={"Two Factor Code"}
              className="form-item"
              wrapperCol={{ span: 24 }}
            >
              <Input placeholder={"Enter Two Factor Code"} maxLength={225} />
            </Form.Item>
          </Modal>
        </ConfigProvider>
        {
          error && (
            <Row>
              <Col
                xs={{ span: 24 }}
                md={{ span: 16, offset: 4 }}
                style={{ marginTop: "10px" }}
              >
                <Alert message={error} type="error" />
              </Col>
            </Row>
          )
        }
        {
          notSignedInCorrectly && (
            <Row>
              <Col
                xs={{ span: 24 }}
                md={{ span: 16, offset: 4 }}
                style={{ marginTop: "10px" }}
              >
                <Alert message="Please sign into Coinbase or Metamask to make a transaction, you cannot make a transaction when you are logged in with the Punkypay Mailroom or Gemini." type="warning" />
              </Col>
            </Row>
          )
        }
      </Form>
    </div>
  );
};

export default Transaction;
